<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button">Chiudi</button>
		</p>
		<div>
			<div class="col-sm-12 coldx">
				<h4>Archivia Pratica</h4>
				<ng-template [ngIf]="dataArchiviazioneForm">
				<form #f="ngForm" [formGroup]="dataArchiviazioneForm" (ngSubmit)="update();">
					<div class="row">
						<div datePickerInput class="col-sm-4"
							[labelInput]="'Data di archiviazione'"
							formControlName="dataArchiviazione"
							[dataAl]="today"
							[(ngModel)]="request.dataArchiviazione" [mandatory]="true"
							[control]="dataArchiviazioneForm.dataArchiviazione"></div>
					</div>
					<div class="row">
						<p class="mandatory col-sm-12">
							<em>* Campi obbligatori</em>
						</p>
					</div>
					<div class="row">
						<p class="col-sm-3 col-xs-6">
							<button type="button" class="btn btn-outline-secondary btn-block"
								(click)="createForm();">Reset</button>
						</p>
						<p submitButton [disabled]="!dataArchiviazioneForm.valid"
							class="col-sm-3 col-xs-6 col-sm-offset-6"
							[labelButton]="'Archivia pratica'"></p>
					</div>
				</form>
				</ng-template>
			</div>
		</div>
	</div>
</div>